import {CSSProperties} from 'react'

import Colors from '@utils/Colors.js'
import {zIndex} from '../UI/styles.js'

// Tokens of the maps' own controls. Everything we lay over a map sits above Leaflet's panes and controls (up to
// 1000), the loading overlay below our controls so they stay usable while loading.

export const mapZIndex = {
    controls: zIndex.mapControls,
    attribution: zIndex.mapControls,
    loading: zIndex.mapControls - 1
}

export const mapSpacing = {
    // Distance of the controls to the map's edge
    inset: 6,
    // Between the zoom card and the cards below it
    cardGap: 24
}

export const mapAttributionSizes = {
    logoHeight: 20,
    // Left of the Mapbox logo on a map with the scale control at the bottom left, next to it
    logoLeftWithScale: 100,
    iconSize: 20
}

/** A control card in the toolbar: no padding, as wide as its buttons */
export const controlCardStyle: CSSProperties = {padding: 0, width: 'fit-content'}

export const loadingOverlayStyle: CSSProperties = {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: mapZIndex.loading,
    background: Colors.white,
    opacity: 0.5
}

/** The map's container: positioned for the controls and its own stacking context, so they don't cover the page */
export const mapContainerStyle: CSSProperties = {position: 'relative', zIndex: 0, width: '100%', height: '100%'}

/** The element Leaflet draws in, filling the container below the controls laid over it */
export const mapElementStyle: CSSProperties = {position: 'absolute', left: 0, top: 0, width: '100%', height: '100%'}
